// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isSkipValidate(props) {
    return props.internalData.modalChildSkipValidate;
}
